import {useState, useEffect} from 'react';
import styled from 'styled-components';

import {useNavigate, useLocation, Navigate, Link} from 'react-router-dom';
import {useAuth} from '../../../contexts/UserContext';
import config from '../../../config';
import LabelWithInfo from '../../atoms/LabelWithInfo';
import {SubInner} from '../../atoms/CommonParts';
import {useApp} from '../../../contexts/AppContext';
import strings from '../../../strings';
import {NotLoginedHeaderArea} from '../../organisms/CommonParts';

const Page = styled.div`

  .header-area {
    margin-bottom: 39px;
    @media ${config.layout.wide} {
      margin-bottom: 51px;
    }
  }
`;

const InputField = styled.input`
  display: block;
  width: 100%;
  font-size: 18px;
`;

const ErrorMessage = styled.div`
  border: 1px solid #FF7323;
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
  text-align: center;
  padding: 20px 20px;
  margin-bottom: 60px;

  a {
    color: #FF7323;
    text-decoration: underline;
  }
`;

const ForgotLinkArea = styled.div`
  margin-top: 16px;
  text-align: right;
  height: 40px;

  a {
    color: #000000;
    text-decoration: underline;
    font-size: 12px;
    @media ${config.layout.wide} {
      font-size: 14px;
    }
    font-weight: 500;
  }
`;

const KeepMeLogin = styled.div`
  text-align: center;
  margin-top: 25px;

  input {
    display: none;

    &:checked {
      & + label {
        &:before {
        }
      }
    }
  }

  label {
    position: relative;
    font-size: 12px;
    font-weight: 500;
    margin-left: 7px;
    padding-left: 28px;

    &:before {
      content: "";
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g id="長方形_167" data-name="長方形 167" fill="%23fff" stroke="%23000" stroke-width="1"><rect width="20" height="20" stroke="none"/><rect x="0.5" y="0.5" width="19" height="19" fill="none"/></g></svg>');
      display: block;
      width: 20px;
      height: 20px;
      background-size: 20px 20px;
      position: absolute;
      left: 0;
      top: -1px;
    }
  }
`;

const DontHaveOneWrap = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
`;

const GotLostInSignup = styled.div`
  width: calc((100% - 20px) / 2);
  flex: 0 0 auto;

  border: 1px solid #000000;
  margin: 30px auto 0;
  text-align: center;
  padding: 20px 0;
  border-radius: 2px;

  p {
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    margin-bottom: 5px;
  }

  a {
    color: #000000;
    text-decoration: underline;
    font-size: 12px;
    font-weight: 500;
  }
`;

const DontHaveOne = styled.div`
  width: calc((100% - 20px) / 2);
  flex: 0 0 auto;

  border: 1px solid #000000;
  margin: 30px auto 0;
  text-align: center;
  padding: 20px 0;
  border-radius: 2px;

  p {
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    margin-bottom: 5px;
  }

  a {
    color: #000000;
    text-decoration: underline;
    font-size: 12px;
    font-weight: 500;
  }
`;

const RegistrationLabel = styled.div`
  margin-top: 40px;
  margin-bottom: 30px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  @media ${config.layout.wide} {
    margin-top: 50px;
  }
`;

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();
  const {hideHeader} = useApp();
  const [errorElm, setErrorElm] = useState('');
  const [errorFieldSet, setErrorFieldSet] = useState(new Set());

  const searchParams = new URLSearchParams(window.location.search);
  let from = '/';
  if (location.state && location.state.from) {
    from =
        `${location.state.from.pathname || ''}${
            location.state.from.search || ''
        }` || '/';
  }
  let customerIDParam = '';
  if (searchParams.has('from')) {
    from = searchParams.get('from');
    if (/\?/.test(from)) {
      try {
        let subsearch = from.replace(/^[^\?]*/i, '');
        const subSearchParams = new URLSearchParams(subsearch);
        customerIDParam = subSearchParams.get('customer_id') || '';
      } catch (e) {
        console.error(e);
      }
    }
  }
  console.log('from', from);
  console.log('customer_id', customerIDParam);

  let defaultValues = (location.state && location.state.initial_params) || {
    venue_code: '',
    email: '',
  };
  let defaultError = (location.state && location.state.error) || null;
  console.log(defaultValues, defaultError);

  useEffect(() => {
    document.title = 'Login';
    hideHeader();
    if (defaultError) {
      setErrorByCode(defaultError);

      try {
        let st = window.history.state;
        delete st.usr.error;
        window.history.replaceState(st, document.title);
      } catch (e) {
        console.error(e);
      }
    }
  }, []);

  if (auth.isLoggedIn()) {
    return (
        <Navigate to={`${from}`} state={{from: location}} replace={true}/>
    );
  }

  function setErrorByCode(code) {
    switch (code) {
      default:
        setErrorElm(<span>Unknown error. Please retry later.</span>);
        break;
      case 401022: // Error Message 4
        setErrorElm(<span>Invalid login or password.</span>);
        //setErrorFieldSet(new Set(["email", "password"]));
        break;

      case 401021: // Error Message 3
        setErrorElm(
            <span>Invalid AlphaTheta Account log in or password.</span>,
        );
        //setErrorFieldSet(new Set(["email", "password"]));
        break;
      case 401025: // Error Message 2
      case 401024: // Error Message 2
      case 401026: // Error Message 2
        setErrorElm(
            <span>
            You need to create a venue account to use this service.{' '}
              <Link
                  to={`/registration/${
                      customerIDParam
                          ? '?customer_id=' +
                          encodeURIComponent(customerIDParam)
                          : ''
                  }`}
              >
              Sign up your venue
            </Link>
          </span>,
        );
        break;

      case 401023: // Error Message 1
        setErrorElm(
            <span>
            This ID is not valid.
            <br/>
            Please enter the valid KUVO ID.
          </span>,
        );
        //setErrorFieldSet(new Set(["venue_code"]));
        break;
      case 401027: //
        setErrorElm(<span>This venue is currently unavailable.</span>);
        break;
    }
  }

  function handleSubmit(event) {
    event.preventDefault();

    let formData = new FormData(event.currentTarget);
    let venue_code = formData.get('venue_code');
    let email = formData.get('email');
    let password = formData.get('password');
    let keep = !!formData.get('keep');

    auth.signin(venue_code, email, password, keep, (err) => {
      setErrorElm('');
      setErrorFieldSet(new Set());
      if (err) {
        const status = (err.response && err.response.status) || 500;
        const code =
            (err.response && err.response.data && err.response.data.code) ||
            500;

        setErrorByCode(code);

        console.error(err.response, status, code);
      } else {
        //  navigate(from, { replace: true });
      }
    });
  }

  return (
      <Page>
        <NotLoginedHeaderArea
            className={'header-area'}
        />

        {errorElm ? (
            <SubInner>
              <ErrorMessage>{errorElm}</ErrorMessage>
            </SubInner>
        ) : (
            ''
        )}

        <form onSubmit={handleSubmit}>
          <SubInner>
            <LabelWithInfo
                text={strings.venue_code}
                labelclassname="login-field-label"
                style={{
                  marginBottom: 20,
                }}
            >
              <div>
                {strings.venue_code_ex}
                <br/>
                <Link
                    to={`/registration/${
                        customerIDParam
                            ? '?customer_id=' +
                            encodeURIComponent(customerIDParam)
                            : ''
                    }`}
                >
                  {strings.pioneer_dj_account_ex_link}
                </Link>
              </div>
            </LabelWithInfo>

            <InputField
                name="venue_code"
                type="text"
                required
                autoComplete="off"
                defaultValue={defaultValues.venue_code || ''}
                className={errorFieldSet.has('venue_code') ? 'error' : 'normal'}
            />

            <ForgotLinkArea>
              <Link to={`/forgot-venue-code/?from=${encodeURIComponent(from)}`}>
                {strings.forgot_your_venue_code}
              </Link>
            </ForgotLinkArea>

            <LabelWithInfo
                text={strings.pioneer_dj_account}
                labelclassname="login-field-label"
                style={{
                  marginTop: 10,
                  marginBottom: 20,
                }}
            >
              <div>
                {strings.pioneer_dj_account_ex}
                <span className="pc">&nbsp;</span>
                <br className="sp"/>-{' '}
                <a
                    href={process.env.REACT_APP_PDJ_DOMAIN +
                        '/en/account/register/'}
                    target="_blank"
                    rel="noopener"
                >
                  {strings.pioneer_dj_account_ex_link}
                </a>
              </div>
            </LabelWithInfo>

            <InputField
                name="email"
                type="email"
                className={errorFieldSet.has('email') ? 'error' : 'normal'}
                required
                defaultValue={defaultValues.email || ''}
                autoComplete="email"
            />

            <LabelWithInfo
                text={strings.password}
                labelclassname="login-field-label"
                style={{
                  marginTop: 30,
                  marginBottom: 20,
                }}
            >
              <div>{strings.password_ex}</div>
            </LabelWithInfo>

            <InputField
                name="password"
                type="password"
                className={errorFieldSet.has('password') ? 'error' : 'normal'}
                required
                autoComplete="current-password"
            />

            <ForgotLinkArea>
              <a
                  href={process.env.REACT_APP_PDJ_DOMAIN +
                      '/en/account/login/'}
                  target="_blank"
                  rel="noopener"
              >
                {strings.forgot_your_password}
              </a>
            </ForgotLinkArea>

            <button
                type="submit"
                className="dark-button center-fixed primary"
                style={{
                  margin: '21px  auto 0',
                }}
            >
              <span>{strings.button_login}</span>
            </button>
            <KeepMeLogin>
              <input
                  id="keep_me_logged_in"
                  name="keep"
                  type="checkbox"
                  defaultChecked
              />
              <label htmlFor="keep_me_logged_in" className={'checkbox-label'}>
                {strings.keep_me_logged_in}
              </label>
            </KeepMeLogin>

            <DontHaveOneWrap>
              <GotLostInSignup>
                <p>Got lost in signup?</p>
                <Link to={`/registration/wizard`}>
                  Signup tutorial
                </Link>
              </GotLostInSignup>
              <DontHaveOne>
                <p>{strings.dont_have_one}</p>
                <a
                    href={process.env.REACT_APP_PDJ_DOMAIN +
                        '/en/account/register/'}
                    target="_blank"
                    rel="noopener"
                >
                  {strings.create_pioneer_dj_account}
                </a>
              </DontHaveOne>
            </DontHaveOneWrap>
          </SubInner>
          <hr className="content-border"/>
          <RegistrationLabel>{strings.kuvo_venue_registration}</RegistrationLabel>

          <Link
              className="dark-button center-fixed primary"
              to={`/registration/${
                  customerIDParam
                      ? '?customer_id=' + encodeURIComponent(customerIDParam)
                      : ''
              }`}
              style={{}}
          >
            <span>{strings.button_registration}</span>
          </Link>
        </form>
      </Page>
  );
}
